import React from 'react';
import { useState, useEffect } from 'react';
import './classes/CourseandConferenceBlock.css';
import './classes/ConferencesBlock.css';
import './classes/CoursesBlock.css';
import { configData } from "../config";

// The "8-Week Courses & Certificates (Alphabetical)" list on the Courses page:
// the courses placed on the page, in their placement order, as on the Drupal site.
// hideHeading: the "jobs in sports" pages show the list under their own heading
const CoursesBlock = ({ page, hideHeading }) => {
    const app_url = configData.APP_URL;
    const [courses, setCourses] = useState([]);

    useEffect(() => {
        if (page?.nid) {
            getcourses(page.nid);
        }
    }, [page?.nid]);

    const getcourses = async (nid) => {
        try {
            const response = await fetch(app_url + 'pages/getcourses?nid=' + nid, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            const responsedata = await response.json();
            if (responsedata.data?.items) {
                setCourses(responsedata.data.items);
            }
        } catch (err) {
            console.error(err);
        }
    };

    // Pictures added on the live site after the Drupal copy was taken are missing there,
    // so try the live site once, then hide the picture so a missing file leaves no broken image
    const retryOrHide = (event) => {
        const img = event.currentTarget;
        const copyFiles = configData.DRUPAL_DOMAIN_URL + '/sites/';
        if (img.src.startsWith(copyFiles)) {
            img.src = configData.DRUPAL_LIVE_DOMAIN_URL + '/sites/' + img.src.slice(copyFiles.length);
        } else {
            img.style.display = 'none';
        }
    };

    if (!courses.length) return null;

    // The id is the Drupal block's: page bodies carry their own styles for it (some hide the heading)

    return (
        <div id="block-views-courses-block" className={"conference-section conferences-block courses-block" + (hideHeading ? " courses-block--no-heading" : "")}>
            {!hideHeading && <h2>8-Week Courses &amp; Certificates <span className="conference-block-text-normal">(Alphabetical)</span>:</h2>}

            <ul className="conference-list">
                {courses.map((course) => {
                    // A course with no start date entered says "Starts Soon"
                    const startsSoon = !course.month;
                    return (
                        <li className="conference-list__item" key={course.nid}>

                            {/* ---------------- Desktop Tile ---------------- */}
                            <div className="conference-tile--desktop">

                                <div className="conference-list__item-image-wrapper">
                                    <a href={course.link}>
                                        {course.image && <img src={course.image} alt={course.title} loading="lazy" onError={retryOrHide} />}
                                    </a>
                                </div>

                                <div className="conference-list__item-details">
                                    <div className="conference-list__item-title title">
                                        <a href={course.link}>{course.title}</a>
                                    </div>

                                    <div className="conference-list__item-intro">
                                        {course.intro}
                                    </div>
                                </div>

                                <div className="conference-list__item-deadline">
                                    <div className="conference-list__item-deadline-badge">
                                        {startsSoon ? (
                                            <span className="badge__starts-soon">Starts<br />Soon</span>
                                        ) : (
                                            <>
                                                <span className="badge__header">{course.month}</span>
                                                <span className="badge__day">{course.day}</span>
                                                <span className="badge__month">Course</span>
                                                <span className="badge__label">Start Date</span>
                                            </>
                                        )}
                                    </div>

                                    <div className="conference-list__item-badge-accent">
                                        <a href={course.link}>
                                            <span className="badge__learn-more-and">LEARN MORE AND</span>
                                            <span className="badge__apply">APPLY</span>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            {/* ---------------- Mobile Tile ---------------- */}
                            <div className="conference-tile--mobile">
                                <div className="views-field-wrap">
                                    <div className="conference-list__item-mobile-header">
                                        <div className="conference-list__item-avatar">
                                            <i>
                                                {course.mobile_icon && <img src={course.mobile_icon} alt="" loading="lazy" onError={retryOrHide} />}
                                            </i>
                                        </div>

                                        <div className="conference-list__item-title title">
                                            <a href={course.link}>{course.title}</a>
                                        </div>
                                    </div>

                                    <div className="conference-list__item-deadline-badge">
                                        <div className="badge__date">
                                            {startsSoon ? 'Starts Soon' : 'Starts ' + course.month + ' ' + course.day}
                                        </div>
                                        <div className="badge__description">{course.description}</div>

                                        <div className="badge__action-container">
                                            <span className="badge__action-btn">
                                                <a href={course.link}>LEARN MORE</a>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default CoursesBlock;
